import axios from "axios";
import store from '@/store'
import router from "@/router";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))


export const findSkeletonToken = (parent, attributeName, attributeValue) => {
    if (!parent) {
        // Reached the root component without finding the attribute
        return null;
    }
    if (parent.$el && parent.$el.childNodes.length > 0 && parent.$el.getAttribute(attributeName) === attributeValue) {
        // Found the parent with the specified attribute
        return parent;
    } else {
        // Continue searching in the parent's parent
        return findSkeletonToken(parent.$parent, attributeName, attributeValue);
    }
}


export default {
    namespaced: true,
    state: {
        skeletonComponentStatus: {},
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        createSkeletonWrapperState({commit, state}, form) {
            state.skeletonComponentStatus[form.id] = form.state
        },
        updateSkeletonWrapperState({commit, state}, form) {
            state.skeletonComponentStatus[form.id] = form.state
        },
        getSkeletonWrapperState({commit, state}, form) {
            return state.skeletonComponentStatus[form.id]
        },
    },
    getters: {
        getFilters: (state) => state.filters,
        getSkeletonComponentStatus: (state) => state.skeletonComponentStatus
    }
}